"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TAXONOMY_CLASSES_SET_IN_USE_TERMINAL_NODES = exports.TAXONOMY_CLASSES_REFRESH = exports.TAXONOMY_CLASSES_SET_IS_LOADING = exports.TAXONOMY_CLASSES_SET_DATA = void 0;
const const_1 = require("../../const");
exports.TAXONOMY_CLASSES_SET_DATA = `${const_1.PREFIX_ENRICH}TAXONOMY_CLASSES_SET_DATA`;
exports.TAXONOMY_CLASSES_SET_IS_LOADING = `${const_1.PREFIX_ENRICH}TAXONOMY_CLASSES_SET_IS_LOADING`;
exports.TAXONOMY_CLASSES_REFRESH = `${const_1.PREFIX_ENRICH}TAXONOMY_CLASSES_REFRESH`;
exports.TAXONOMY_CLASSES_SET_IN_USE_TERMINAL_NODES = `${const_1.PREFIX_ENRICH}TAXONOMY_CLASSES_SET_IN_USE_TERMINAL_NODES`;
